module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/pop-bg.74897b85.png";